import React from 'react';
import classNames from 'classnames';
var upperCaseRegExp = /(?=.*[A-Z])/;
var lowerCaseRegExp = /(?=.*[a-z])/;
var symbolsRegExp = /(?=.*?[!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~])/;
var digitsRegExp = /(?=.*?[0-9])/;
/**
 *
 * @param value
 * @return {boolean}
 */
export function validPassword(value) {
    return value && value.length >= 12 &&
        upperCaseRegExp.test(value) &&
        lowerCaseRegExp.test(value) &&
        symbolsRegExp.test(value) &&
        digitsRegExp.test(value);
}
/**
 *
 */
export default function PasswordValidator(props) {
    var value = props.value;
    var classes = classNames({
        'password-validator d-block w-100 mb-4 pl-3': true,
        'password-validator--show': value && value.length > 0,
        'password-validator--hide': !(value && value.length > 0)
    });
    return React.createElement("div", { className: classes },
        React.createElement(PasswordValidatorRule, { isValid: value.length >= 12 },
            React.createElement("span", { className: "" }, "Minimaal 12 karakters")),
        React.createElement(PasswordValidatorRule, { isValid: upperCaseRegExp.test(value) },
            React.createElement("span", { className: "" }, "Hoofdletters")),
        React.createElement(PasswordValidatorRule, { isValid: lowerCaseRegExp.test(value) },
            React.createElement("span", { className: "" }, "Kleine letters")),
        React.createElement(PasswordValidatorRule, { isValid: symbolsRegExp.test(value) },
            React.createElement("span", { className: "" }, "Symbolen")),
        React.createElement(PasswordValidatorRule, { isValid: digitsRegExp.test(value) },
            React.createElement("span", { className: "" }, "Cijfers")));
}
PasswordValidator.defaultProps = {
    value: ''
};
function PasswordValidatorRule(props) {
    var classes = classNames({
        'password-validator__rule d-flex align-items-center': true,
        'password-validator__rule--validated': props.isValid
    });
    return React.createElement("div", { className: classes },
        props.children,
        props.isValid ? React.createElement("span", { className: "ml-3 fe fe-check-circle text-success" }) : null);
}
/**
 *
 match value with
 | s when containsOnlyDigits s ->
 Error(Invalid((Some(addErrDetails errInfoOption "CannotContainsOnlyNumbers"))))
 | s when value.Length < 12 && not (containsAnySymbol s) ->
 Error(Invalid((Some(addErrDetails errInfoOption "ShortPasswordsMustContainSymbols"))))
 | s when value.Length < 16 && not (containsAnyNumber s) ->
 Error(Invalid((Some(addErrDetails errInfoOption "ShortPasswordsMustContainNumbers"))))
 | s when value.Length < 20 && not (containsMixedCase s) ->
 Error(Invalid((Some(addErrDetails errInfoOption "ShortPasswordsMustContainMixedCaseChars"))))
 | s when startsWithPartialStrWhenGtOne s forEmail ->
 Error(Invalid((Some(addErrDetails errInfoOption "CannotStartWithSameValueAsEmail"))))
 | s when startsWithPartialStrWhenGtOne s forFirstname ->
 Error(Invalid((Some(addErrDetails errInfoOption "CannotStartWithSameValueAsFirstname"))))
 | s when startsWithPartialStrWhenGtOne s forLastname ->
 Error(Invalid((Some(addErrDetails errInfoOption "CannotStartWithSameValueAsLastname"))))
 | s when containsPartialStrWhenGtOne s forEmail ->
 Error(Invalid((Some(addErrDetails errInfoOption "CannotContainPartOfEmail"))))
 | s when containsPartialStrWhenGtOne s forFirstname ->
 Error(Invalid((Some(addErrDetails errInfoOption "CannotContainPartOfFirstname"))))
 | s when containsPartialStrWhenGtOne s forLastname ->
 Error(Invalid((Some(addErrDetails errInfoOption "CannotContainPartOfLastname"))))
 | _ -> Ok(T requiredStr)
 */
